import { LoginChannel, OtpErrorCode } from '@flowaccount/core/ui'

export class EmailVerificationInfoModel {
  readonly emailConfirmed: boolean
  readonly userId: number
  loginChannel: LoginChannel = null
  isPostpone: boolean = false

  constructor(emailConfirmed: boolean, userId: number, loginChannel: LoginChannel) {
    this.emailConfirmed = emailConfirmed
    this.userId = userId
    this.loginChannel = loginChannel
  }
}

export class OtpVerificationModalInfoModel {
  initial: boolean = true
}

export class EmailVerificationErrorInfoModel {
  errorCode: OtpErrorCode = null
}

export class EmailVerificationConfig {
  deadline: Date
}

// #region OTP Resend Model
export class OtpResendRequestModel {
  initial: boolean
}

export class OtpResendResponseModel {
  allowResendOn: Date
  attempNo: number
  expiredOn: Date
  maxAttemps: number
  timestamp: Date
}
// #endregion

// #region OTP Resend Model
export class OtpVerifyRequestModel {
  otp: string
}

export class OtpVerifyResponseModel {
  attempNo: number
  isVerified: boolean
  verifiedOn: Date
}
// #endregion

export enum OtpStatus {
  Idle,
  Incorrect,
  Expired,
}

export enum OtpResendStatus {
  Idle,
  Cooldown,
  Locked,
}
